


















































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import ObatComboField from "../ObatComboField.vue";
import { formatWaktu } from "./antimikrobaReserve.config";
import PermintaanObatPaketSvc from "@/services/PermintaanObatPaket";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import { storePenunjang } from "@/store/modules/penunjang";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import { userModule } from "@/store/modules/user";

@Component({
  components: { CardModalTtd, ObatComboField },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AntimikrobaReserveForm extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData!: any;
  @Prop({ default: false }) readonly!: boolean;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  jenisPaket = "antimikroba_reserve";
  saving = false;
  savingKpra = false;
  loadingDetail = false;
  modalTtd = false;
  ttdMode: "dpjp" | "kpra" = "dpjp";
  currentData: any = null;

  keadaanUmumOptions = ["CM", "Somnolen", "Stupor", "Koma", "Lain"];

  rekomendasiKpraOptions = [
    { text: "Disetujui", value: "disetujui" },
    { text: "Tidak Disetujui", value: "tidak_disetujui" }
  ];

  form: any = {
    dpjp_id: null,
    diagnosa: "",
    jenis_bayar: "",
    ruang_rawat: "",
    tanggal_mrs: "",
    pasien_rujukan: false,
    keadaan_umum: "",
    keadaan_umum_lain: "",
    td_sistole: "",
    td_diastole: "",
    nadi: "",
    suhu: "",
    rr: "",
    has_alergi: false,
    alergi_detail: "",
    hasil_kultur: "tidak_ada",
    hasil_lab_relevan: "tidak_ada",
    items: [],
    alasan_klinis: "",
    nama_kpra: "",
    rekomendasi_kpra: null,
    tanggal_kpra: "",
    tanggal_dpjp_ttd: "",
    catatan: ""
  };

  get isLocked() {
    return this.readonly || this.sudahDikirim;
  }

  get sudahDikirim(): boolean {
    return !!(this.currentData && this.currentData.dikirim_at);
  }

  get canCatatKpra(): boolean {
    const d = this.currentData;
    return (
      !!d &&
      !!d.dikirim_at &&
      !d.kpra_verified_at &&
      userModule.hasPrivilege("antimikroba_reserve", "update")
    );
  }

  get canVerifikasiKpra(): boolean {
    const d = this.currentData;
    return (
      !!d &&
      !!d.kpra_dicatat_at &&
      !d.kpra_verified_at &&
      userModule.hasPrivilege("antimikroba_reserve", "verify")
    );
  }

  get kpraHint(): string {
    const d = this.currentData;
    if (d && d.kpra_verified_at) return "";
    if (!this.sudahDikirim) {
      return "Diisi farmasi setelah permintaan dikirim ke farmasi.";
    }
    if (!this.canCatatKpra) {
      return "Diisi farmasi berdasarkan hasil konsul KPRA, lalu diverifikasi Ketua KPRA/PGA.";
    }
    return "";
  }

  get bisaTtdDpjp(): boolean {
    const d = this.currentData;
    return !!d && !d.signed_dpjp && !!d.dpjp && d.dpjp.id == userModule.user.id;
  }

  get ttdHint(): string {
    return this.ttdMode === "kpra"
      ? "Masukkan PIN/ Password untuk memverifikasi persetujuan KPRA sebagai Ketua KPRA/PGA"
      : "";
  }

  get dokterList() {
    return storeDokter.listAll;
  }

  async mounted() {
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }

    if (this.editData) {
      await this.loadDetail(this.editData.id);
    } else {
      this.autoFillFromStores();
      if (!this.form.items.length) {
        this.addItem();
      }
    }
  }

  async loadDetail(id: number) {
    this.loadingDetail = true;
    try {
      const resp = await PermintaanObatPaketSvc.find(id);
      if (resp.data.status === "1") {
        this.currentData = resp.data.data;
        this.populateForm();
      }
    } catch {
      // handled by service
    }
    this.loadingDetail = false;
  }

  populateForm() {
    if (!this.currentData) return;
    const d = this.currentData;
    this.form = {
      dpjp_id: d.dpjp ? d.dpjp.id : null,
      diagnosa: d.diagnosa || "",
      jenis_bayar: d.jenis_bayar || "",
      ruang_rawat: d.ruang_rawat || "",
      tanggal_mrs: d.tanggal_mrs || "",
      pasien_rujukan: d.pasien_rujukan || false,
      keadaan_umum: d.keadaan_umum || "",
      keadaan_umum_lain: d.keadaan_umum_lain || "",
      td_sistole: d.td_sistole || "",
      td_diastole: d.td_diastole || "",
      nadi: d.nadi || "",
      suhu: d.suhu || "",
      rr: d.rr || "",
      has_alergi: d.has_alergi || false,
      alergi_detail: d.alergi_detail || "",
      hasil_kultur: d.hasil_kultur || "tidak_ada",
      hasil_lab_relevan: d.hasil_lab_relevan || "tidak_ada",
      items: (d.items || []).map((item: any) => ({
        obat_id: item.obat_id || null,
        nama_antimikroba: item.nama_antimikroba || "",
        regimen: item.regimen || item.regimen_aturan_pakai || "",
        aturan_pakai: item.aturan_pakai || ""
      })),
      alasan_klinis: d.alasan_klinis || "",
      nama_kpra: d.nama_kpra || "",
      rekomendasi_kpra: d.rekomendasi_kpra || null,
      tanggal_kpra: d.tanggal_kpra || "",
      tanggal_dpjp_ttd: d.tanggal_dpjp_ttd || "",
      catatan: d.catatan || ""
    };
  }

  autoFillFromStores() {
    const reg = RegisterKunjungan.register;

    if (reg?.dokter?.id) this.form.dpjp_id = reg.dokter.id;

    const pasien = storePasien.identitasPasien;
    if (pasien?.register?.asr?.nama)
      this.form.jenis_bayar = pasien.register.asr.nama;
    if (pasien?.alergi) {
      this.form.has_alergi = true;
      this.form.alergi_detail = pasien.alergi;
    }

    const asesmen = AsesmenAwalRanapMedisStore.asesmen;
    if (asesmen?.diagnosis) this.form.diagnosa = asesmen.diagnosis;

    if (reg?.jurnal_ranap?.length) {
      const lastJurnal = reg.jurnal_ranap[reg.jurnal_ranap.length - 1];
      if (lastJurnal?.unit?.name) this.form.ruang_rawat = lastJurnal.unit.name;
      const firstJurnal = reg.jurnal_ranap[0];
      if (firstJurnal?.tgl_in)
        this.form.tanggal_mrs = firstJurnal.tgl_in.substring(0, 10);
    }

    const tvList = TandaVitalStore.list;
    if (tvList?.length) {
      const latest = tvList[0];
      if (latest.keadaan_umum) this.form.keadaan_umum = latest.keadaan_umum;
      if (latest.sistole) this.form.td_sistole = String(latest.sistole);
      if (latest.diastole) this.form.td_diastole = String(latest.diastole);
      if (latest.frekuensi_nadi) this.form.nadi = String(latest.frekuensi_nadi);
      if (latest.suhu_badan) this.form.suhu = String(latest.suhu_badan);
      if (latest.frekuensi_nafas) this.form.rr = String(latest.frekuensi_nafas);
    }

    const labList = storePenunjang.listhasilLab;
    if (labList?.length) {
      this.form.hasil_lab_relevan = "ada";
      const hasKultur = labList.some(
        (lab: any) => lab.hasil_mikro && lab.hasil_mikro.trim() !== ""
      );
      if (hasKultur) this.form.hasil_kultur = "ada";
    }
  }

  addItem() {
    this.form.items.push({
      obat_id: null,
      nama_antimikroba: "",
      regimen: "",
      aturan_pakai: ""
    });
  }

  removeItem(idx: number) {
    this.form.items.splice(idx, 1);
  }

  async doSave() {
    if (this.readOnly) return;
    if (!this.form.dpjp_id) {
      appModule.NoticeDelay("DPJP harus diisi");
      return;
    }
    if (!this.form.diagnosa) {
      appModule.NoticeDelay("Diagnosa harus diisi");
      return;
    }
    if (!this.form.keadaan_umum) {
      appModule.NoticeDelay("Keadaan umum harus diisi");
      return;
    }
    if (!this.form.alasan_klinis) {
      appModule.NoticeDelay("Alasan klinis harus diisi");
      return;
    }

    const validItems = this.form.items.filter((i: any) => i.nama_antimikroba);
    if (!validItems.length) {
      appModule.NoticeDelay("Minimal 1 item antimikroba harus diisi");
      return;
    }

    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        jenis_paket: this.jenisPaket,
        dpjp_id: this.form.dpjp_id,
        diagnosa: this.form.diagnosa,
        jenis_bayar: this.form.jenis_bayar,
        has_alergi: this.form.has_alergi,
        alergi_detail: this.form.has_alergi ? this.form.alergi_detail : null,
        items: validItems,
        catatan: this.form.catatan,
        tanggal_mrs: this.form.tanggal_mrs || null,
        ruang_rawat: this.form.ruang_rawat || null,
        keadaan_umum: this.form.keadaan_umum,
        keadaan_umum_lain:
          this.form.keadaan_umum === "Lain"
            ? this.form.keadaan_umum_lain
            : null,
        pasien_rujukan: this.form.pasien_rujukan,
        hasil_kultur: this.form.hasil_kultur,
        hasil_lab_relevan: this.form.hasil_lab_relevan,
        td_sistole: this.form.td_sistole || null,
        td_diastole: this.form.td_diastole || null,
        nadi: this.form.nadi || null,
        suhu: this.form.suhu || null,
        rr: this.form.rr || null,
        alasan_klinis: this.form.alasan_klinis,
        tanggal_dpjp_ttd: this.form.tanggal_dpjp_ttd || null
      };

      if (this.currentData && this.currentData.id) {
        await PermintaanObatPaketSvc.update(this.currentData.id, payload);
        appModule.NoticeDelay("Berhasil mengupdate data");
      } else {
        await PermintaanObatPaketSvc.create(payload);
        appModule.NoticeDelay("Berhasil menyimpan data");
      }

      this.$emit("saved");
    } catch {
      // handled by service
    }
    this.saving = false;
  }

  formatWaktu(nilai: string | null) {
    return formatWaktu(nilai);
  }

  async simpanKpra() {
    if (!this.form.nama_kpra || !this.form.rekomendasi_kpra || !this.form.tanggal_kpra) {
      appModule.NoticeDelay("Nama KPRA, rekomendasi, dan tanggal KPRA harus diisi");
      return;
    }
    this.savingKpra = true;
    try {
      await PermintaanObatPaketSvc.catatKpra(this.currentData.id, {
        nama_kpra: this.form.nama_kpra,
        rekomendasi_kpra: this.form.rekomendasi_kpra,
        tanggal_kpra: this.form.tanggal_kpra
      });
      appModule.NoticeDelay("Persetujuan KPRA berhasil dicatat");
      this.$emit("saved");
    } catch {
      // handled by service
    }
    this.savingKpra = false;
  }

  openVerifikasiModal() {
    this.ttdMode = "kpra";
    this.modalTtd = true;
  }

  openSignModal() {
    this.ttdMode = "dpjp";
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.currentData || !this.currentData.id) return;
    if (this.ttdMode === "kpra") {
      try {
        const resp = await PermintaanObatPaketSvc.verifikasiKpra(this.currentData.id, {
          password
        });
        if (resp.data.status === "1") {
          this.modalTtd = false;
          appModule.NoticeDelay("Persetujuan KPRA berhasil diverifikasi");
          this.$emit("saved");
        }
      } catch {
        // handled by service
      }
      return;
    }
    try {
      const resp = await PermintaanObatPaketSvc.signDpjp(this.currentData.id, {
        password
      });
      if (resp.data.status === "1") {
        this.modalTtd = false;
        appModule.NoticeDelay("Berhasil menandatangani sebagai DPJP");
        await this.loadDetail(this.currentData.id);
      }
    } catch {
      // handled by service
    }
  }
}
